import PlatfromConfigState from '../interfaces/state';

const platfromConfigInitialState: PlatfromConfigState = {
  cityConfigs: null,
  servicePrices: null,
  checkoutPause: null,
};

export default platfromConfigInitialState;
